import {
  DataGrid as MuiDataGrid,
  type DataGridProps,
  type GridValidRowModel,
} from '@mui/x-data-grid';
import { alpha } from '@mui/material/styles';
import { formatPaginationDisplayedRows } from '@/lib/formatPaginationDisplayedRows';

export { GridActionsCellItem, type GridColDef } from '@mui/x-data-grid-pro';

export function DataGrid<T extends GridValidRowModel>(props: DataGridProps<T>) {
  const { sx: sxProp, slotProps: slotPropsProp, ...rest } = props;

  const slotProps = {
    ...slotPropsProp,
    pagination: {
      ...slotPropsProp?.pagination,
      labelDisplayedRows:
        (
          slotPropsProp?.pagination as
            | { labelDisplayedRows?: typeof formatPaginationDisplayedRows }
            | undefined
        )?.labelDisplayedRows ?? formatPaginationDisplayedRows,
    },
  } as DataGridProps<T>['slotProps'];

  return (
    <MuiDataGrid
      getRowClassName={(params) =>
        params.indexRelativeToCurrentPage % 2 === 0 ? 'even' : 'odd'
      }
      paginationMode="server"
      slotProps={slotProps}
      {...rest}
      sx={[
        (theme) => ({
          '&.MuiDataGrid-root': {
            borderWidth: '0px',
            minHeight: '200px',
            bgcolor: 'background.paper',

            '.MuiDataGrid-overlayWrapper': {
              minHeight: '200px',
            },
          },
          '.MuiDataGrid-topContainer::after': {
            backgroundColor: 'unset',
          },
          '.MuiDataGrid-columnHeader': {
            color: 'text.primary',
            bgcolor: 'background.paper',
          },
          '.MuiDataGrid-columnHeaderTitleContainerContent': {
            fontSize: '14px',
            fontWeight: '500',
            letterSpacing: '0.1px',
            color: 'text.primary',
          },
          '.MuiDataGrid-row.even .MuiDataGrid-cell--pinnedRight': {
            bgcolor: 'background.default',
          },
          '.MuiDataGrid-row.odd .MuiDataGrid-cell--pinnedRight': {
            bgcolor: 'background.paper',
          },
          '.MuiDataGrid-cell': {
            borderWidth: '0px',
            // Typography variant=bodysmall
            fontSize: '14px',
            fontWeight: '400',
            letterSpacing: '0.25px',
          },
          '.MuiDataGrid-footerContainer': {
            borderWidth: '0px',
            bgcolor: 'background.paper',
          },
          '.even': {
            bgcolor: 'background.default',
          },
          '.odd': {
            bgcolor: 'background.paper',
          },
          '.MuiTablePagination-root': {
            color: 'text.secondary',

            '.MuiTablePagination-select': {
              borderWidth: '1px',
              borderStyle: 'solid',
              borderColor: 'primary.main',
              borderRadius: '999px',
              padding: '8px',
              paddingRight: '32px !important',
              color: 'primary.main',
              transition: 'none',
            },
            '.MuiTablePagination-input svg': {
              color: 'primary.main',
              right: '8px',
            },
            '.MuiTablePagination-actions .MuiButtonBase-root:not(.Mui-disabled)':
              {
                color: 'primary.main',
                backgroundColor: theme.vars
                  ? `rgba(${theme.vars.palette.primary.mainChannel} / 0.08)`
                  : alpha(theme.palette.primary.main, 0.08),
                borderRadius: '999px',
                width: '32px',
                height: '32px',
                svg: {
                  margin: '0px 6px',
                },
              },
          },
        }),
        ...(Array.isArray(sxProp) ? sxProp : sxProp ? [sxProp] : []),
      ]}
    />
  );
}
